import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useFetchApi from "./useFetchApi";


const usePageData = (myCustomPath?: string) => {
    const location = useLocation();
    const path = myCustomPath || location.pathname;

    const {
        data,
        isLoading
    } = useFetchApi({
        url: "/v1/page" + path + "?response=json",
        service: "CMS_PROC"
    });

    return {
        data: data?.data,
        page: data?.page,
        localization: data?.localization,
        isLoading
    }
}

export default usePageData;